import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import { Image } from "../Image/Image/Image";
import styles from "./FloatyImage.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var defaultFloatyImageImageProps = {
  image1x: '',
  image2x: '',
  alt: '',
  retainImageDimensions: false,
  loading: 'lazy'
};
var defaultFloatyImagePositionProps = {
  x: '0px',
  y: '0px'
};
export var defaultFloatyImageProps = {
  image: _objectSpread({}, defaultFloatyImageImageProps),
  position: _objectSpread({}, defaultFloatyImagePositionProps)
};
export var FloatyImage = function FloatyImage(_ref) {
  var _ref$image = _ref.image,
    image = _ref$image === void 0 ? defaultFloatyImageImageProps : _ref$image,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? defaultFloatyImagePositionProps : _ref$position;
  return image !== null && image !== void 0 && image.image1x ? /*#__PURE__*/_jsx(Image, {
    className: styles.floaty,
    src: image.image1x || '',
    srcTwoX: image.image2x || '',
    style: {
      transform: "translate3d(".concat(position.x || '0px', ", ").concat(position.y || '0px', ", 0)")
    },
    alt: image.alt || ''
    // TODO Lazy loading fails when the image is positioned slightly off screen.
    // We should remove this in the future if that issue is solved.
    ,
    loading: image.loading || 'lazy'
  }) : null;
};